<template>
  <div class="image">
    <img
      :src="value.imageFile.url"
      :alt="value.alt ?? ''"
      :width="value.imageFile.width"
      :height="value.imageFile.height"
    >
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.image {
  width: 100%;
  display: flex;
  margin: 2.4rem 0;

  img {
    max-width: 100%;
    height: auto;
    border-radius: .8rem;
    outline: 1px solid $border-color;
    outline-offset: -1px;
  }
}
</style>
